import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { projects } from '../mock';
import { useFeaturedProjects } from '../hooks/useFeaturedProjects';
import { ProjectCard } from './projects/ProjectCard';
import { FeaturedProjectsHeader } from './projects/FeaturedProjectsHeader';

const Projects = () => {
  const { scrollerRef, featured, scrollBy } = useFeaturedProjects(projects);
  return (
    <section className="relative py-28 lg:py-36 overflow-hidden">
      <FeaturedProjectsHeader scrollBy={scrollBy} />
      <div ref={scrollerRef} data-testid="featured-projects-carousel" className="projects-scroll relative flex gap-5 overflow-x-auto pl-6 lg:pl-10 pr-6 lg:pr-10 pb-6 snap-x snap-mandatory">
        {featured.map((project) => <ProjectCard key={project.slug} project={project} featured />)}
        <div className="shrink-0 w-4" />
      </div>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mt-14 text-center">
        <Link data-testid="featured-projects-all-button" to="/projeler" className="inline-flex items-center gap-2 text-[13px] tracking-[0.18em] font-semibold text-accent hover:text-white transition-colors group">TUM PROJELERIMIZI INCELEYIN<ChevronRight size={16} className="group-hover:translate-x-1 transition-transform" /></Link>
      </div>
    </section>
  );
};

export default Projects;